export const SCROLL_TO_TOP_VISIBLE_AFTER_PX = 400

export function isScrollToTopVisible(scrollY = window.scrollY): boolean {
  return scrollY > SCROLL_TO_TOP_VISIBLE_AFTER_PX
}
